import { render, staticRenderFns } from "./FormContent.vue?vue&type=template&id=a0bce04e&scoped=true&"
import script from "./FormContent.vue?vue&type=script&lang=ts&"
export * from "./FormContent.vue?vue&type=script&lang=ts&"
import style0 from "./FormContent.vue?vue&type=style&index=0&id=a0bce04e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bce04e",
  null
  
)

export default component.exports